/**
 * Carbon table toolbar (DESIGN.md "Data table"): a 48px row on layer-01 that
 * holds TableSearch, TableSelect, TableFilterMenu and icon actions. Below
 * c-md it wraps, the search taking its own row. `batch` takes a
 * BatchActionBar, which slides down over the toolbar while rows are
 * selected; it is clipped to the toolbar so the filter popover is not.
 * While `covered` (the batch bar is showing), the controls under it are inert
 * and hidden from assistive tech, so keyboard and screen-reader users can't
 * reach what sighted users can't see; the row keeps its height.
 * DataTable renders this for you from its `toolbar` prop.
 */
import type { ReactNode } from 'react'
import clsx from 'clsx'
import { inertWhen } from './a11y'

export interface TableToolbarProps {
  children?: ReactNode
  /** A BatchActionBar, layered over the toolbar. */
  batch?: ReactNode
  /** The batch bar covers the toolbar (rows are selected): the controls under it go inert. */
  covered?: boolean
  className?: string
}

export function TableToolbar({ children, batch, covered = false, className }: TableToolbarProps) {
  return (
    <div className={clsx('relative flex min-h-12 min-w-0 bg-layer-1', className)}>
      <div
        {...inertWhen(covered)}
        aria-hidden={covered || undefined}
        className="flex min-h-12 min-w-0 flex-1 flex-wrap items-stretch c-md:flex-nowrap"
      >
        {children}
      </div>
      {batch ? <div className="pointer-events-none absolute inset-0 z-[2] overflow-hidden">{batch}</div> : null}
    </div>
  )
}

export default TableToolbar
